import axios from 'axios';
import { apiCube, AuthorizationCube } from '../utils/index';

export const FETCH_CHARTS_INFO_BEGIN = 'FETCH_CHARTS_INFO_BEGIN';
export const FETCH_CHARTS_INFO_SUCCESS = 'FETCH_CHARTS_INFO_SUCCESS';
export const FETCH_CHARTS_INFO_FAILURE = 'FETCH_CHARTS_INFO_FAILURE';

function fetchChartsInfoSuccess(id, dataParams) {
  return {
    type: FETCH_CHARTS_INFO_SUCCESS,
    payload: { id, dataParams }
  };
}

function fetchChartsInfoFailure() {
  return {
    type: FETCH_CHARTS_INFO_FAILURE
  };
}

export function fetchCharts(id, loadQuery) {
  if (AuthorizationCube)
    axios.defaults.headers.common.Authorization = AuthorizationCube;
  return dispatch => {
    return axios
      .get(`${apiCube}cubejs-api/v1${loadQuery}`)
      .then(response => response.data)
      .then(dataParams => dispatch(fetchChartsInfoSuccess(id, dataParams)))
      .catch(() => dispatch(fetchChartsInfoFailure()));
  };
}
